<summa-side-panel-content [showInfo]="true" class="side-panel" *ngIf="sandbox.user$ | async as user">
  <ng-container header>
    <h1><span class="orange">{{'reseller:users.preview.title-prefix' | i18nextCap }}: </span>{{ user.username }}</h1>
  </ng-container>

  <ng-container info></ng-container>
</summa-side-panel-content>
